import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { Photo } from '../../models/wsre.model';
import { WsreService } from '../../wsre.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-framecomponent-photo-popup',
  templateUrl: './framecomponent-photo-popup.component.html',
  styleUrls: ['./framecomponent-photo-popup.component.scss']
})
export class FramecomponentPhotoPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FramecomponentPhotoPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wsreService: WsreService,
    private _sanitizer: DomSanitizer,
    private _service: NotificationsService) { }

    photo: Photo;
    loadingPhoto: boolean = true;
    photoIsDeleting: boolean = false;
    userCanDeletePhoto = false;
    childId:number|null;

  ngOnInit() {
    this.userCanDeletePhoto = this.data.userCanDeletePhoto;
    // if(this.data.childId){
    //     this._wsreService.getIdlerPartPhoto(this.data.photoId, this.data.photoType,this.data.childId).subscribe(photo => {
    //         this.photo = photo;
    //         this.loadingPhoto = false;
    //     });
    // }else{
        this._wsreService.GetComponentFramePhoto(this.data.photoId, this.data.photoType).subscribe(photo => {
            this.photo = photo;
            this.loadingPhoto = false;
        });
   // }
    
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

deletePhoto() {
  this.photoIsDeleting = true;

  this._wsreService.DeleteComponentframePhoto(this.data.photoId, this.data.photoType).subscribe(deleted => {
      if (deleted) {
          this.photoIsDeleting = false;
          this._service.success('Deleted', 'The photo was deleted successfully. ');
          this.dialogRef.close(true);
      } else {
          this.photoIsDeleting = false;
          this._service.error('Failed', 'Failed to delete the photo. ');
      }
  });   

}
onNoClick(): void {
  this.dialogRef.close();
}

}
